import 'bootstrap';
import initLenis from './modules/lenis';
import initGsap from './modules/gsap';
import initLoader from './modules/loader';
import initNavbar from './modules/navbar';
import initScrollIndicator from './modules/scroll-indicator';
import initSwiper from './modules/swiper';
import initClubSwiper from './modules/club-swiper';
import initSubscribeForm from './modules/subscribe-form';

document.addEventListener('DOMContentLoaded', () => {
  initLenis();
  initLoader();
  initNavbar();
  initGsap();
  initScrollIndicator();
  initSwiper();
  initClubSwiper();
  initSubscribeForm();

  const scrollTopBtn = document.querySelector('.scroll-to-top-btn');
  if (scrollTopBtn) {
    scrollTopBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (window.lenis) {
        window.lenis.scrollTo('#banner', { duration: 1.5 });
      } else {
        const target = document.getElementById('banner');
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  const navCtaBtn = document.querySelector('.navbar-cta-btn');
  if (navCtaBtn) {
    navCtaBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (window.lenis) {
        window.lenis.scrollTo('#section-6', { duration: 1.5 });
      } else {
        const target = document.getElementById('section-6');
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }
});
